const PackageConfirmationEmailMarkup = (completedOrderDetails) => {
    return `
        // To Do
    `;
}

export default PackageConfirmationEmailMarkup;